import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { COUNTRIES } from "@/lib/api";

export default function Products() {
  return (
    <ResourcePage
      title="Products" name="Product" endpoint="products"
      subtitle="Your international pharmaceutical export catalogue"
      emptyMessage="No products yet. Add your first export-grade product to start building your catalogue."
      canExport
      statusOptions={["active", "inactive", "draft"]}
      columns={[
        { key: "name", label: "Product" },
        { key: "generic_name", label: "Generic" },
        { key: "dosage_form", label: "Form" },
        { key: "strength", label: "Strength" },
        { key: "therapeutic_category", label: "Therapeutic" },
        { key: "status", label: "Status", type: "status" },
      ]}
      defaultValues={{ status: "active", target_countries: [] }}
      formFields={[
        { name: "name", label: "Product name", required: true, full: true },
        { name: "generic_name", label: "Generic name" },
        { name: "brand_name", label: "Brand name" },
        { name: "category", label: "Product category" },
        { name: "therapeutic_category", label: "Therapeutic category" },
        { name: "dosage_form", label: "Dosage form", type: "select", options: ["Tablet", "Capsule", "Injection", "Syrup", "Inhaler", "Ointment", "Suspension"] },
        { name: "strength", label: "Strength" },
        { name: "packaging", label: "Packaging" },
        { name: "moq", label: "Min order quantity" },
        { name: "status", label: "Status", type: "select", options: ["active", "inactive", "draft"] },
        { name: "description", label: "Description", type: "textarea", full: true },
      ]}
    />
  );
}
